import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=3df1b5c2"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=3df1b5c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports